import React, { useState, useEffect } from 'react';
import api from "../services/api";
import ApoieButton from '../components/ApoieButton/ApoieButton';
import PageHero from "../components/PageHero/PageHero";
import ContactForm from "../components/Contato/Form/Form";
import ContactInfo from "../components/Contato/Info/Info";
import SuccessModal from "../components/Contato/Modal/Modal";
import heroFallbackUrl from "../assets/images/metodologia-hero-shaped.png";
import './Contato.css';

const fallbackCmsData = {
  institucional: {
    titulo: "Fale diretamente conosco!",
    descricao: "Entre em contato pelo telefone (35) 3822-6251 ou pelo e-mail comunicacao@7geracoes.org.br."
  },
  textosFormulario: {
    nameLabel: "Nome",
    namePlaceholder: "Insira seu nome",
    emailLabel: "E-mail",
    emailPlaceholder: "Insira seu e-mail",
    phoneLabel: "Telefone",
    phonePlaceholder: "Ex: (89) 9999-9999",
    subjectLabel: "Assunto",
    subjectPlaceholder: "Selecione o assunto",
    messageLabel: "Mensagem",
    messagePlaceholder: "Que mensagem você quer deixar para a gente?",
    botaoEnviar: "Enviar",
    mensagemSucesso: "Enviado com sucesso!"
  },
  opcoesAssunto: [
    { id: "1", valor: "ouvidoria", rotulo: "Ouvidoria" },
    { id: "2", valor: "curriculo", rotulo: "Currículo" },
    { id: "3", valor: "sugestao", rotulo: "Sugestão" },
    { id: "4", valor: "doacao", rotulo: "Doação" },
    { id: "5", valor: "newsletter", rotulo: "Cadastro para receber notícias" }
  ]
};

const Contato = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [cmsData, setCmsData] = useState(fallbackCmsData);

  useEffect(() => {
    const fetchContactPageData = async () => {
      try {
        const response = await api.get('/contato');
        const dbData = response.data;

        if (dbData) {
          setCmsData(prevData => ({
            institucional: {
              ...prevData.institucional,
              descricao: dbData.informativeText || prevData.institucional.descricao
            },
            textosFormulario: {
              ...prevData.textosFormulario,
              namePlaceholder: dbData.nameField?.placeholder || prevData.textosFormulario.namePlaceholder,
              emailPlaceholder: dbData.emailField?.placeholder || prevData.textosFormulario.emailPlaceholder,
              phonePlaceholder: dbData.phoneField?.placeholder || prevData.textosFormulario.phonePlaceholder,
              subjectPlaceholder: dbData.subjectField?.placeholder || prevData.textosFormulario.subjectPlaceholder,
              messagePlaceholder: dbData.messageField?.placeholder || prevData.textosFormulario.messagePlaceholder
            },
            opcoesAssunto: dbData.subjectField?.subjects?.length > 0
              ? dbData.subjectField.subjects.map((subject, idx) => ({
                  id: String(idx),
                  valor: subject.name,
                  rotulo: subject.name
                }))
              : prevData.opcoesAssunto
          }));
        }
      } catch (error) {
        console.error("Erro ao buscar dados do CMS. Usando conteúdo padrão.", error);
      }
    };

    fetchContactPageData();
  }, []);

  return (
    <>
      <PageHero
        imageUrl={heroFallbackUrl}
        imageShape="provided"
        title="Contato"
      />
      
      <main className="contato-container">
        <section className="contato-content">
          <ContactForm 
            cmsData={cmsData} 
            onSuccess={() => setShowSuccess(true)} 
          />
          <ContactInfo 
            institucional={cmsData.institucional} 
          />
        </section>

        <ApoieButton />
      </main>

      {showSuccess && (
        <SuccessModal 
          mensagemSucesso={cmsData.textosFormulario.mensagemSucesso} 
          onClose={() => setShowSuccess(false)} 
        />
      )}
    </>
  );
};

export default Contato;